export const errors = {
  // Authentication errors
  AUTH_INVALID_CREDENTIALS: 'Invalid credentials',
  AUTH_INCORRECT_PASSWORD: 'Current password is incorrect',
  AUTH_ACCOUNT_LOCKED: 'Account is locked. Please try again later.',
  AUTH_ACCOUNT_DISABLED: 'Account is disabled',
  AUTH_2FA_REQUIRED: '2FA code required',
  AUTH_INVALID_2FA: 'Invalid 2FA code',
  TURNSTILE_REQUIRED: 'Please complete the verification challenge and try again.',
  TURNSTILE_FAILED: 'Verification failed. Please try again.',
  TURNSTILE_NOT_CONFIGURED: 'Verification is temporarily unavailable. Please try again later.',
  AUTH_USER_NOT_FOUND: 'User not found',
  AUTH_TOKEN_EXPIRED: 'Session expired. Please login again.',
  AUTH_INVALID_TOKEN: 'Invalid or expired token',
  AUTH_2FA_ALREADY_ENABLED: '2FA already enabled or user not found',
  AUTH_2FA_NOT_INITIATED: '2FA setup not initiated',
  AUTH_2FA_NOT_ENABLED: 'User does not have 2FA enabled',
  AUTH_REQUIRED: 'Authentication required',
  AUTH_INSUFFICIENT_PERMISSIONS: 'Insufficient permissions for this action',
  AUTH_USER_INACTIVE: 'User account is inactive',

  // User management errors
  USER_NOT_FOUND: 'User not found',
  USER_ALREADY_EXISTS: 'User already exists',
  USER_EMAIL_IN_USE: 'Email is already in use',
  USER_USERNAME_IN_USE: 'Username is already in use',
  USER_CANNOT_DELETE_SELF: 'You cannot delete your own account',
  USER_INVALID_ROLE: 'Invalid role',
  USER_INACTIVE: 'User account is inactive',
  USER_UPDATE_FAILED: 'Failed to update user',
  USER_DELETE_FAILED: 'Failed to delete user',

  // Validation errors
  VALIDATION_FAILED: 'Validation failed',
  VALIDATION_REQUIRED_FIELD: 'This field is required',
  VALIDATION_INVALID_EMAIL: 'Invalid email format',
  VALIDATION_PASSWORD_TOO_WEAK: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
  VALIDATION_PASSWORDS_NOT_MATCH: 'Passwords do not match',
  VALIDATION_MISSING_FIELD: 'Required field is missing',
  VALIDATION_INVALID_FORMAT: 'Invalid field format',
  VALIDATION_OUT_OF_RANGE: 'Value is out of allowed range',

  // Permission errors
  PERMISSION_DENIED: 'Permission denied',
  PERMISSION_INSUFFICIENT: 'Insufficient permissions',

  // Settings errors
  SETTINGS_NOT_FOUND: 'Settings not found',
  SETTINGS_UPDATE_FAILED: 'Failed to update settings',
  SETTINGS_INVALID_VALUE: 'Invalid setting value',
  SETTINGS_FILE_TOO_LARGE: 'File size exceeds limit',
  SETTINGS_INVALID_FILE_TYPE: 'Invalid file type',

  // Charger errors
  CHARGER_NOT_FOUND: 'Charger not found',
  CHARGER_OFFLINE: 'Charger is offline',
  CHARGER_UNAVAILABLE: 'Charger is unavailable',
  CHARGER_OCCUPIED: 'Charger is occupied by another vehicle',
  CHARGER_FAULTED: 'Charger has a fault condition',
  CHARGER_HAS_ACTIVE_SESSIONS: 'Charger has active sessions and cannot be deleted',
  CHARGER_STATION_ID_EXISTS: 'Station ID already exists',
  CHARGER_REBOOT_FAILED: 'Failed to reboot charger',

  // Charger Type errors
  CHARGER_TYPE_NOT_FOUND: 'Charger type not found',
  CHARGER_TYPE_IN_USE: 'Charger type is in use and cannot be deleted',
  CHARGER_TYPE_NAME_EXISTS: 'Charger type name already exists',

  // Load Group errors
  LOAD_GROUP_NOT_FOUND: 'Load group not found',
  LOAD_GROUP_HAS_CHARGERS: 'Load group has chargers and cannot be deleted',
  LOAD_GROUP_NAME_EXISTS: 'Load group name already exists',

  // Connector errors
  CONNECTOR_NOT_FOUND: 'Connector not found',
  CONNECTOR_CABLE_NOT_CONNECTED: 'Charging cable is not connected. Please connect the cable first.',
  CONNECTOR_ALREADY_CHARGING: 'Connector is already in a charging session',
  CONNECTOR_FINISHING: 'Previous charging session is finishing. Please wait.',
  CONNECTOR_UNAVAILABLE: 'Connector is unavailable',
  CONNECTOR_FAULTED: 'Connector has a fault condition',
  CONNECTOR_NOT_READY: 'Connector is not ready for charging',
  CONNECTOR_VERIFICATION_FAILED: 'Connector readiness verification failed',

  // Session errors
  SESSION_NOT_FOUND: 'Charging session not found',
  SESSION_ALREADY_ACTIVE: 'A charging session is already active',
  SESSION_NOT_ACTIVE: 'No active charging session',
  SESSION_NOT_STOPPABLE: 'Cannot stop the charging session at this time',
  SESSION_INIT_FAILED: 'Failed to initialize charging session',
  SESSION_START_FAILED: 'Failed to start charging session',
  SESSION_STOP_FAILED: 'Failed to stop charging session',
  SESSION_ALREADY_COMPLETED: 'Session is already completed',
  SESSION_FORCE_COMPLETE_FAILED: 'Failed to force complete session',

  // Fee errors
  FEE_SCHEDULE_NOT_FOUND: 'No active fee schedule configured for this charger',
  FEE_STRUCTURE_INVALID: 'Fee schedule configuration is invalid',
  FEE_TEMPLATE_NOT_FOUND: 'Fee template not found',
  FEE_TEMPLATE_IN_USE: 'Fee template is in use and cannot be deleted',
  FEE_TEMPLATE_NAME_EXISTS: 'Fee template name already exists',
  FEE_CALCULATION_FAILED: 'Fee calculation failed',
  FEE_SCHEDULE_OVERLAPPING: 'Fee schedule overlaps with existing schedule',
  FEE_SCHEDULE_ACTIVE: 'Fee schedule is active and cannot be deleted',
  FEE_ADJUSTMENT_NOT_FOUND: 'Fee adjustment not found',
  FEE_ADJUSTMENT_ALREADY_APPLIED: 'Fee adjustment has already been applied',
  FEE_CHANGE_ALREADY_PROCESSED: 'Fee change has already been processed',

  // OCPP errors
  OCPP_SERVER_NOT_FOUND: 'OCPP server not found',
  OCPP_SERVER_NOT_CONFIGURED: 'OCPP server is not configured for this charger',
  OCPP_SERVER_INACTIVE: 'OCPP server is currently inactive',
  OCPP_SERVER_AUTH_FAILED: 'OCPP server authentication failed',
  OCPP_SERVER_HAS_CHARGERS: 'OCPP server has chargers and cannot be deleted',
  OCPP_SERVER_ENDPOINT_EXISTS: 'OCPP server endpoint URL already exists',
  OCPP_COMMUNICATION_FAILED: 'Failed to communicate with OCPP server',
  OCPP_COMMAND_REJECTED: 'OCPP command was rejected by the charger',
  OCPP_COMMAND_TIMEOUT: 'OCPP command timed out',
  OCPP_TEMPLATE_NOT_FOUND: 'OCPP template not found',
  OCPP_TEMPLATE_IN_USE: 'OCPP template is in use and cannot be deleted',
  OCPP_TEMPLATE_NAME_EXISTS: 'OCPP template name already exists',

  // LMS Template errors
  LMS_TEMPLATE_NOT_FOUND: 'LMS template not found',
  LMS_TEMPLATE_IN_USE: 'LMS template is in use and cannot be deleted',
  LMS_TEMPLATE_NAME_EXISTS: 'LMS template name already exists',

  // Supabase Connection errors
  SUPABASE_CONNECTION_NOT_FOUND: 'Supabase connection not found',
  SUPABASE_CONNECTION_FAILED: 'Supabase connection test failed',
  SUPABASE_CONNECTION_IN_USE: 'Supabase connection is in use and cannot be deleted',
  SUPABASE_CONNECTION_NAME_EXISTS: 'A Supabase connection with this name already exists',

  // Site errors
  SITE_NOT_FOUND: 'Site not found',
  SITE_INACTIVE: 'Site is inactive',
  SITE_HAS_CHARGERS: 'Site has chargers and cannot be deleted',
  SITE_HAS_KIOSKS: 'Premises has kiosk registrations and cannot be deleted',
  SITE_NAME_EXISTS: 'Site name already exists',

  // Role errors
  ROLE_NOT_FOUND: 'Role not found',
  ROLE_IN_USE: 'Role is assigned to users and cannot be deleted',
  ROLE_NAME_EXISTS: 'Role name already exists',

  // Vendor errors
  VENDOR_NOT_FOUND: 'Vendor not found',
  VENDOR_HAS_SITES: 'Vendor has sites and cannot be deleted',
  VENDOR_HAS_HISTORY: 'This merchant has API or charging history and cannot be deleted. Deactivate it instead.',
  VENDOR_NAME_EXISTS: 'Vendor name already exists',

  // App User errors
  APP_USER_NOT_FOUND: 'App user not found',
  APP_USER_HAS_BALANCE: 'App user has remaining balance',
  APP_USER_HAS_ACTIVE_SESSIONS: 'App user has active charging sessions',

  // RFID errors
  RFID_USER_NOT_FOUND: 'RFID user not found',
  RFID_USER_EMAIL_EXISTS: 'RFID user email already exists',
  RFID_USER_HAS_CARDS: 'RFID user has cards and cannot be deleted',
  RFID_CARD_NOT_FOUND: 'RFID card not found',
  RFID_CARD_NUMBER_EXISTS: 'RFID card number already exists',
  RFID_CARD_HAS_TRANSACTIONS: 'RFID card has transactions and cannot be deleted',

  // Promotion errors
  PROMOTION_NOT_FOUND: 'Promotion not found',
  PROMOTION_CODE_EXISTS: 'Promotion code already exists',
  PROMOTION_HAS_REDEMPTIONS: 'Promotion has redemptions and cannot be deleted',

  // Banner errors
  BANNER_NOT_FOUND: 'Banner not found',

  // Message errors
  MESSAGE_NOT_FOUND: 'Message not found',
  MESSAGE_NO_RECIPIENTS: 'No recipients specified for message',
  MESSAGE_SEND_FAILED: 'Failed to send message',

  // Notification errors
  NOTIFICATION_GROUP_NOT_FOUND: 'Notification group not found',
  NOTIFICATION_GROUP_HAS_MEMBERS: 'Notification group has members and cannot be deleted',
  NOTIFICATION_GROUP_NAME_EXISTS: 'Notification group name already exists',

  // File errors
  FILE_TOO_LARGE: 'File size exceeds limit',
  FILE_INVALID_TYPE: 'Invalid file type',
  FILE_UPLOAD_FAILED: 'File upload failed',

  // Firmware errors
  FIRMWARE_NOT_FOUND: 'Firmware not found',
  FIRMWARE_VERSION_EXISTS: 'Firmware version already exists',
  FIRMWARE_IN_USE: 'Firmware is in use and cannot be deleted',
  FIRMWARE_UPDATE_NOT_FOUND: 'Firmware update not found',
  FIRMWARE_UPDATE_NO_CHARGERS: 'No eligible chargers for firmware update',
  FIRMWARE_UPDATE_ALREADY_COMPLETED: 'Firmware update has already completed',

  // Resource errors
  RESOURCE_NOT_FOUND: 'Resource not found',
  RESOURCE_ALREADY_EXISTS: 'Resource already exists',
  RESOURCE_IN_USE: 'Resource is in use and cannot be modified',
  RESOURCE_CREATE_FAILED: 'Failed to create resource',
  RESOURCE_UPDATE_FAILED: 'Failed to update resource',
  RESOURCE_DELETE_FAILED: 'Failed to delete resource',

  // Database errors
  DATABASE_ERROR: 'Database error occurred',
  DATABASE_CONNECTION_FAILED: 'Database connection failed',
  DATABASE_QUERY_FAILED: 'Database query failed',
  DATABASE_CONSTRAINT_VIOLATION: 'Database constraint violation',

  // External service errors
  EXTERNAL_SERVICE_ERROR: 'External service error',
  EXTERNAL_SERVICE_TIMEOUT: 'External service timed out',
  EXTERNAL_SERVICE_UNAVAILABLE: 'External service is unavailable',

  // General errors
  INTERNAL_ERROR: 'An internal error occurred',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNKNOWN_ERROR: 'An unknown error occurred',
  SERVICE_UNAVAILABLE: 'Service temporarily unavailable',
  OPERATION_FAILED: 'Operation failed',
  RATE_LIMIT_EXCEEDED: 'Rate limit exceeded. Please try again later.',
  INVALID_REQUEST: 'Invalid request',
};